export default function cloudinary(url, options) {
  if (!options) {
    return url;
  }

  return url.replace('q_auto', `${options}/q_auto`);
}
